import React, {useState, useEffect} from 'react';
import { Timeline } from 'antd';
import styles from '../../assets/styles/modules/Timeline.module.css'
import dot_main from '../../assets/images/ico-timeline-main.svg'
import dot_sub from '../../assets/images/ico-timeline-sub.svg'
import TimelineCardWithThumbnail from "./cardNews/TimelineCardWithThumbnail";
import TimelineCard from "./cardNews/TimelineCard";
import {getSimilarNewsAPI} from '../../apis/news_service'

const ItemTimeline = ({news}) => {
    const [relatedNews, setRelatedNews] = useState([]);

    const getRelatedNews = () => {getSimilarNewsAPI(news.newsid, news.samenewscounts).then(res => setRelatedNews(res))}
    useEffect(getRelatedNews, [])


    return (
        <div className={styles.timeline_item}>
            <Timeline
                style={{maxWidth:'545px'}}
                mode="right" //left, right, alternate
                items={[
                    {
                        dot: <img src={dot_main} alt='dot' className={styles.dot_img}/>,
                        children: <TimelineCardWithThumbnail news={news} main=''/>,
                    },
                    {
                        dot: <img src={dot_main} alt='dot' style={{opacity:0}}/>,
                        children: '',
                    }
                ]}
            />

            {!!relatedNews &&
                <Timeline
                mode="left" //left, right, alternate
                items={[...relatedNews.map(data => {
                    return (
                        {
                            dot:<img src={dot_sub} alt='dot' className={styles.dot_img}/>,
                            children: <TimelineCard news={data} main=''/>,
                        }
                    )
                }),  { dot:<img src={dot_sub} alt='dot' style={{opacity:0}}/>,children: '',}]}
            />
            }
        </div>

    );
};

export default ItemTimeline;

